module.exports = __webpack_public_path__ + "static/media/bills_true.533a6ab9.png";